// extracted by mini-css-extract-plugin
module.exports = {"component":"spinner_component__oiEAm","dark":"spinner_dark__oykR1","light":"spinner_light__UtE9z","medium":"spinner_medium__lRKAr"};